// extracted by mini-css-extract-plugin
export default {"contributed__header":"Contributed_contributed__header__rtJD8","contributed__img":"Contributed_contributed__img__6Q+pr"};